import { Routes, Route } from 'react-router-dom';
import { FlowBuilder } from './pages/FlowBuilder';
import { Dashboard } from './pages/Dashboard';
import { Settings } from './pages/Settings';

import { Navbar } from './components/Navbar';
import { ToastContainer } from './components/Toast';
import { useToast } from './hooks/useToast';
import { AuthGuard } from './components/Auth/AuthGuard';
import EventBuilder from './pages/events/EventBuilder';

function App() {
  const { toasts, removeToast } = useToast();

  // Hide navbar for public forms (public forms are now handled by Form App)
  const isPublicForm = false;

  return (
    <div className="min-h-screen bg-gray-50" data-color-mode="light">
      <AuthGuard>
        {!isPublicForm && <Navbar />}
        <main className={isPublicForm ? '' : 'container mx-auto px-4 py-8'}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/builder/:flowId?" element={<FlowBuilder />} />
            <Route
              path="/builder/:flowId/localization/:languageCode?"
              element={<FlowBuilder mode="localize" />}
            />
            <Route
              path="/builder/events/:eventId?"
              element={<EventBuilder />}
            />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
        <ToastContainer toasts={toasts} onRemove={removeToast} />
      </AuthGuard>
    </div>
  );
}

export default App;
